import {getFormationsByPage, getFormations, getAcademies, getFormationsList} from './formations';

export const apiFormations = {
  getFormations,
  getAcademies,
  getFormationsList,
  getFormationsByPage,
};
